export default class PaginationConsts {
    static readonly regularPageSize = 10;
    static readonly largePageSize = 20;
}
